// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"hot-content-widget_shadow__3TA4U","wrapper":"hot-content-widget_wrapper__3S6T4"};